<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-body-1">
          {{ componentData.description }}
        </div>
      </v-col>
      <v-col cols="12" class="py-3" align="center">
        <div>
          <v-img :src="img" width="130" height="130"></v-img>
        </div>
      </v-col>
      <v-col>
        <div class="py-1"></div>
        <v-btn block large color="primary" @click="StartUsing()">
          <span class="mx-2 text-capitalize">{{
            componentData.startUsing
          }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VerifyEmailExpired",
  data() {
    return {
      componentData: {
        title: "註冊完成",
        description: "歡迎您加入小芋頭，享受各式服務",
        startUsing: "開始使用",
      },
      iconSettinn: {
        name: "mdi-close-circle-outline",
        color: "warning",
        size: "50",
      },
      img: require("@/assets/image/components/bigCheck.svg"),
    };
  },
  methods: {
    StartUsing() {
      let email = localStorage.getItem("_emailEncrypt");
      this.GoFromSite(email);
      window.close();
    },
    // 從哪來回哪去
    GoFromSite(emailEncrypt) {
      let fromCmid = localStorage.getItem("fromCmid");
      if (fromCmid) {
        localStorage.removeItem("fromCmid");
        window.location.href = `${this.$store.state.fromSite.url}/writeInvitedForm?cmid=${fromCmid}&uem=${emailEncrypt}`;
      } else {
        window.location.href =
          this.$store.state.fromSite.url + "?emailEncrypt=" + emailEncrypt;
      }
    },
  },
};
</script>
